<script setup>
import { useStore } from '@/store';
import { useI18n } from '@/locales';

const props = defineProps({
  helpCenterUrl: {
    type: String,
    default: '',
  },
});

const store = useStore();
const { t } = useI18n();

const options = [
  {
    icon: 'lightbulb-on',
    text: t('automation.onboardingModal.title'),
    dataTestId: 'onboardingModalOption',
    action: () => store.dispatch('automation/openOnboardingModal', { triggerOrigin: 'help' }),
  },
  {
    icon: 'external-link',
    text: t('general.help.helpCenter'),
    dataTestId: 'helpCenterOption',
    href: props.helpCenterUrl,
    target: '_blank',
  },
];
</script>

<template>
  <XDropdownMenu
    :options="options"
    placement="bottom-end"
    data-testid="helpButton"
  >
    <template #activator="{ on }">
      <XButton
        design="text"
        @click="on"
      >
        {{ $t('base.help') }}
        <XIcon
          icon="question-circle"
          right
        />
      </XButton>
    </template>
  </XDropdownMenu>
</template>
